import React, { Component } from 'react';
import $ from 'jquery';

class Jukebox extends Component {
  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip();
    let $curSongID = localStorage.getItem('curSongID'),
        $curSongTitle = localStorage.getItem('curSongTitle');
    //if track is in the playlist
    if ($('#tracks ul li[data-id='+$curSongID+']').length) {
      //remove active status on tracks
      $('#tracks ul li').removeClass('active');
      //add active status on active track
      if ($curSongTitle && $curSongID) {
        $('#tracks ul li span').each(function(){
          if ($(this).text() === $curSongTitle) {
            $(this).parent().addClass('active');
            $('html, body').animate({
              scrollTop: $('#tracks ul li[data-id='+$curSongID+']').offset().top - 100
            }, 2000);
          }
        });
      }
    }

    let $pinned = localStorage.getItem('pinnedPlaylistDrawer');
    if ($pinned === '1') {
      localStorage.setItem('pinnedPlaylistDrawer', 1);
      $('#pin-playlists, #playlists, #jukebox, #catalog, a.navbar-brand').addClass('pinned');
    }
  }

  render() {
    return (
      <div id="jukebox">
        <div id="tracks" className="track-list">
          <ul id="track-group" className="list-group">
            {this.props.tracks}
          </ul>
        </div>
      </div>
    );
  }
}

export default Jukebox;
